import { render, staticRenderFns } from "./PostsFeed.vue?vue&type=template&id=abccdc78"
import script from "./PostsFeed.vue?vue&type=script&lang=js"
export * from "./PostsFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abccdc78')) {
      api.createRecord('abccdc78', component.options)
    } else {
      api.reload('abccdc78', component.options)
    }
    module.hot.accept("./PostsFeed.vue?vue&type=template&id=abccdc78", function () {
      api.rerender('abccdc78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/PostsFeed.vue"
export default component.exports